// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file dashboard_service.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DashboardAvailability } from "./dashboard_pb";
import { file_dashboard } from "./dashboard_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dashboard_service.proto.
 */
export const file_dashboard_service: GenFile = /*@__PURE__*/
  fileDesc("ChdkYXNoYm9hcmRfc2VydmljZS5wcm90bxILZ3JwYy5hcGkudjEiLAocRGFzaGJvYXJkQXZhaWxhYmlsaXR5UmVxdWVzdBIMCgRkYXRlGAEgASgFIlkKHURhc2hib2FyZEF2YWlsYWJpbGl0eVJlc3BvbnNlEjgKDGF2YWlsYWJpbGl0eRgBIAEoCzIiLmdycGMuYXBpLnYxLkRhc2hib2FyZEF2YWlsYWJpbGl0eSIjCiFEYXNoYm9hcmRNdWx0aUFjY291bnRTdGF0c1JlcXVlc3QioQEKGERhc2hib2FyZEFjY291bnREYXlTdGF0cxIMCgRkYXRlGAEgASgFEhQKDHJlc2VydmF0aW9ucxgCIAEoBRIOCgZndWVzdHMYAyABKAUSEAoIbm9fc2hvd3MYBCABKAUSFQoNY2FuY2VsbGF0aW9ucxgFIAEoBRISCgpyYXRpbmdfc3VtGAYgASgFEhQKDHJhdGluZ19jb3VudBgHIAEoBSKdAQoXRGFzaGJvYXJkQWNjb3VudFJldmVudWUSDAoEZGF0ZRgBIAEoBRIVCg1jdXJyZW5jeV9jb2RlGAIgASgJEhcKD2RlcG9zaXRfcmV2ZW51ZRgDIAEoAxITCgtjY2dfcmV2ZW51ZRgEIAEoAxIYChBnaWZ0Y2FyZF9yZXZlbnVlGAUgASgDEhUKDXBheW1lbnRfY291bnQYBiABKAUi2AEKFURhc2hib2FyZEFjY291bnRTdGF0cxISCgphY2NvdW50X2lkGAEgASgFEgwKBGNpdHkYAiABKAkSMwoEZGF5cxgDIAMoCzIlLmdycGMuYXBpLnYxLkRhc2hib2FyZEFjY291bnREYXlTdGF0cxI2CghyZXZlbnVlcxgEIAMoCzIkLmdycGMuYXBpLnYxLkRhc2hib2FyZEFjY291bnRSZXZlbnVlEhcKD2VuYWJsZV9mZWVkYmFjaxgFIAEoCBIXCg9hbGxvd19tdWx0aWRhc2gYBiABKAgigAEKIkRhc2hib2FyZE11bHRpQWNjb3VudFN0YXRzUmVzcG9uc2USEgoKYmVnaW5fZGF0ZRgBIAEoBRIQCghlbmRfZGF0ZRgCIAEoBRI0CghhY2NvdW50cxgDIAMoCzIiLmdycGMuYXBpLnYxLkRhc2hib2FyZEFjY291bnRTdGF0cyI2Ch9EYXNoYm9hcmRTZXRBY2NvdW50T3JkZXJSZXF1ZXN0EhMKC2FjY291bnRfaWRzGAEgAygFIiIKIERhc2hib2FyZFNldEFjY291bnRPcmRlclJlc3BvbnNlMuUCChBEYXNoYm9hcmRTZXJ2aWNlEmgKD2dldEF2YWlsYWJpbGl0eRIpLmdycGMuYXBpLnYxLkRhc2hib2FyZEF2YWlsYWJpbGl0eVJlcXVlc3QaKi5ncnBjLmFwaS52MS5EYXNoYm9hcmRBdmFpbGFiaWxpdHlSZXNwb25zZRJ3ChRnZXRNdWx0aUFjY291bnRTdGF0cxIuLmdycGMuYXBpLnYxLkRhc2hib2FyZE11bHRpQWNjb3VudFN0YXRzUmVxdWVzdBovLmdycGMuYXBpLnYxLkRhc2hib2FyZE11bHRpQWNjb3VudFN0YXRzUmVzcG9uc2USbgoPc2V0QWNjb3VudE9yZGVyEiwuZ3JwYy5hcGkudjEuRGFzaGJvYXJkU2V0QWNjb3VudE9yZGVyUmVxdWVzdBotLmdycGMuYXBpLnYxLkRhc2hib2FyZFNldEFjY291bnRPcmRlclJlc3BvbnNlQgZaBC47cGJiBnByb3RvMw", [file_dashboard]);

/**
 * @generated from message grpc.api.v1.DashboardAvailabilityRequest
 */
export type DashboardAvailabilityRequest = Message<"grpc.api.v1.DashboardAvailabilityRequest"> & {
  /**
   * @generated from field: int32 date = 1;
   */
  date: number;
};

/**
 * Describes the message grpc.api.v1.DashboardAvailabilityRequest.
 * Use `create(DashboardAvailabilityRequestSchema)` to create a new message.
 */
export const DashboardAvailabilityRequestSchema: GenMessage<DashboardAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 0);

/**
 * @generated from message grpc.api.v1.DashboardAvailabilityResponse
 */
export type DashboardAvailabilityResponse = Message<"grpc.api.v1.DashboardAvailabilityResponse"> & {
  /**
   * @generated from field: grpc.api.v1.DashboardAvailability availability = 1;
   */
  availability?: DashboardAvailability | undefined;
};

/**
 * Describes the message grpc.api.v1.DashboardAvailabilityResponse.
 * Use `create(DashboardAvailabilityResponseSchema)` to create a new message.
 */
export const DashboardAvailabilityResponseSchema: GenMessage<DashboardAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 1);

/**
 * @generated from message grpc.api.v1.DashboardMultiAccountStatsRequest
 */
export type DashboardMultiAccountStatsRequest = Message<"grpc.api.v1.DashboardMultiAccountStatsRequest"> & {
};

/**
 * Describes the message grpc.api.v1.DashboardMultiAccountStatsRequest.
 * Use `create(DashboardMultiAccountStatsRequestSchema)` to create a new message.
 */
export const DashboardMultiAccountStatsRequestSchema: GenMessage<DashboardMultiAccountStatsRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 2);

/**
 * @generated from message grpc.api.v1.DashboardAccountDayStats
 */
export type DashboardAccountDayStats = Message<"grpc.api.v1.DashboardAccountDayStats"> & {
  /**
   * YYYYMMDD, account-local
   *
   * @generated from field: int32 date = 1;
   */
  date: number;

  /**
   * valid reservations only
   *
   * @generated from field: int32 reservations = 2;
   */
  reservations: number;

  /**
   * sum of party sizes, valid reservations only
   *
   * @generated from field: int32 guests = 3;
   */
  guests: number;

  /**
   * @generated from field: int32 no_shows = 4;
   */
  noShows: number;

  /**
   * @generated from field: int32 cancellations = 5;
   */
  cancellations: number;

  /**
   * @generated from field: int32 rating_sum = 6;
   */
  ratingSum: number;

  /**
   * @generated from field: int32 rating_count = 7;
   */
  ratingCount: number;
};

/**
 * Describes the message grpc.api.v1.DashboardAccountDayStats.
 * Use `create(DashboardAccountDayStatsSchema)` to create a new message.
 */
export const DashboardAccountDayStatsSchema: GenMessage<DashboardAccountDayStats> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 3);

/**
 * @generated from message grpc.api.v1.DashboardAccountRevenue
 */
export type DashboardAccountRevenue = Message<"grpc.api.v1.DashboardAccountRevenue"> & {
  /**
   * YYYYMMDD, account-local
   *
   * @generated from field: int32 date = 1;
   */
  date: number;

  /**
   * @generated from field: string currency_code = 2;
   */
  currencyCode: string;

  /**
   * hundredths of the major currency unit
   *
   * @generated from field: int64 deposit_revenue = 3;
   */
  depositRevenue: bigint;

  /**
   * hundredths of the major currency unit
   *
   * @generated from field: int64 ccg_revenue = 4;
   */
  ccgRevenue: bigint;

  /**
   * hundredths of the major currency unit
   *
   * @generated from field: int64 giftcard_revenue = 5;
   */
  giftcardRevenue: bigint;

  /**
   * @generated from field: int32 payment_count = 6;
   */
  paymentCount: number;
};

/**
 * Describes the message grpc.api.v1.DashboardAccountRevenue.
 * Use `create(DashboardAccountRevenueSchema)` to create a new message.
 */
export const DashboardAccountRevenueSchema: GenMessage<DashboardAccountRevenue> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 4);

/**
 * @generated from message grpc.api.v1.DashboardAccountStats
 */
export type DashboardAccountStats = Message<"grpc.api.v1.DashboardAccountStats"> & {
  /**
   * @generated from field: int32 account_id = 1;
   */
  accountId: number;

  /**
   * @generated from field: string city = 2;
   */
  city: string;

  /**
   * sparse - only days with activity
   *
   * @generated from field: repeated grpc.api.v1.DashboardAccountDayStats days = 3;
   */
  days: DashboardAccountDayStats[];

  /**
   * sparse, one row per (day, currency)
   *
   * @generated from field: repeated grpc.api.v1.DashboardAccountRevenue revenues = 4;
   */
  revenues: DashboardAccountRevenue[];

  /**
   * account_settings EnableFeedback; rating fields are zeroed when false
   *
   * @generated from field: bool enable_feedback = 5;
   */
  enableFeedback: boolean;

  /**
   * multidash subscription feature; days and revenues are empty when false
   *
   * @generated from field: bool allow_multidash = 6;
   */
  allowMultidash: boolean;
};

/**
 * Describes the message grpc.api.v1.DashboardAccountStats.
 * Use `create(DashboardAccountStatsSchema)` to create a new message.
 */
export const DashboardAccountStatsSchema: GenMessage<DashboardAccountStats> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 5);

/**
 * @generated from message grpc.api.v1.DashboardMultiAccountStatsResponse
 */
export type DashboardMultiAccountStatsResponse = Message<"grpc.api.v1.DashboardMultiAccountStatsResponse"> & {
  /**
   * YYYYMMDD inclusive
   *
   * @generated from field: int32 begin_date = 1;
   */
  beginDate: number;

  /**
   * YYYYMMDD inclusive
   *
   * @generated from field: int32 end_date = 2;
   */
  endDate: number;

  /**
   * @generated from field: repeated grpc.api.v1.DashboardAccountStats accounts = 3;
   */
  accounts: DashboardAccountStats[];
};

/**
 * Describes the message grpc.api.v1.DashboardMultiAccountStatsResponse.
 * Use `create(DashboardMultiAccountStatsResponseSchema)` to create a new message.
 */
export const DashboardMultiAccountStatsResponseSchema: GenMessage<DashboardMultiAccountStatsResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 6);

/**
 * @generated from message grpc.api.v1.DashboardSetAccountOrderRequest
 */
export type DashboardSetAccountOrderRequest = Message<"grpc.api.v1.DashboardSetAccountOrderRequest"> & {
  /**
   * full ordered list; position = 1-based order
   *
   * @generated from field: repeated int32 account_ids = 1;
   */
  accountIds: number[];
};

/**
 * Describes the message grpc.api.v1.DashboardSetAccountOrderRequest.
 * Use `create(DashboardSetAccountOrderRequestSchema)` to create a new message.
 */
export const DashboardSetAccountOrderRequestSchema: GenMessage<DashboardSetAccountOrderRequest> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 7);

/**
 * @generated from message grpc.api.v1.DashboardSetAccountOrderResponse
 */
export type DashboardSetAccountOrderResponse = Message<"grpc.api.v1.DashboardSetAccountOrderResponse"> & {
};

/**
 * Describes the message grpc.api.v1.DashboardSetAccountOrderResponse.
 * Use `create(DashboardSetAccountOrderResponseSchema)` to create a new message.
 */
export const DashboardSetAccountOrderResponseSchema: GenMessage<DashboardSetAccountOrderResponse> = /*@__PURE__*/
  messageDesc(file_dashboard_service, 8);

/**
 * @generated from service grpc.api.v1.DashboardService
 */
export const DashboardService: GenService<{
  /**
   * @generated from rpc grpc.api.v1.DashboardService.getAvailability
   */
  getAvailability: {
    methodKind: "unary";
    input: typeof DashboardAvailabilityRequestSchema;
    output: typeof DashboardAvailabilityResponseSchema;
  },
  /**
   * @generated from rpc grpc.api.v1.DashboardService.getMultiAccountStats
   */
  getMultiAccountStats: {
    methodKind: "unary";
    input: typeof DashboardMultiAccountStatsRequestSchema;
    output: typeof DashboardMultiAccountStatsResponseSchema;
  },
  /**
   * writes only the caller's own selector ordering - safe under the service's ungated read-only posture
   *
   * @generated from rpc grpc.api.v1.DashboardService.setAccountOrder
   */
  setAccountOrder: {
    methodKind: "unary";
    input: typeof DashboardSetAccountOrderRequestSchema;
    output: typeof DashboardSetAccountOrderResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dashboard_service, 0);

